import { RefObject, useEffect, useRef } from "react";

export const useInfiniteScroll = (
  fetchPage: () => void,
  enabled = true,
  scrollRootRef?: RefObject<Element | null>,
) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const fetchPageRef = useRef(fetchPage);
  const wasIntersectingRef = useRef(false);

  useEffect(() => {
    fetchPageRef.current = fetchPage;
  }, [fetchPage]);

  useEffect(() => {
    const currentTarget = ref.current;
    const scrollRoot = scrollRootRef?.current ?? null;

    const observer = new IntersectionObserver(
      entries => {
        const isIntersecting = !!entries[0]?.isIntersecting;
        const wasIntersecting = wasIntersectingRef.current;
        wasIntersectingRef.current = isIntersecting;

        if (isIntersecting && !wasIntersecting && enabled) {
          fetchPageRef.current();
        }
      },
      {
        root: scrollRoot,
        rootMargin: "200px",
        threshold: 0,
      },
    );

    if (currentTarget) {
      observer.observe(currentTarget);
    }

    return () => {
      if (currentTarget) {
        observer.unobserve(currentTarget);
      }
    };
  }, [enabled, scrollRootRef]);

  return ref;
};
